export default __webpack_public_path__ + "static/media/dialofdestiny005.ea7686ec.jpeg";